<template>
    <div class="question-list-page">
        <question-trees @selectClick="selectHandle"></question-trees>
        <div class="question-table scroll-tracker">
            <div class="content-top">
                <p>
                    <span class="tit">{{ currentScene }}</span
                    >（{{ $t("zhiji.common.total") }} <em>{{ standTotal }}</em> {{ $t("zhiji.knowlege.standQustUnit") }}，<em>{{ extandTotal }}</em>
                    {{ $t("zhiji.knowlege.similarQustUnit") }}，<em>{{ answerTotal }}</em> {{ $t("zhiji.knowlege.answerUnit") }}）
                </p>
                <OperationBar class="content-opeat" @initCurrPage="initCurrPage" :standTotal="standTotal" :initQuestionId="initQuestionId" />
            </div>
            <Table
                :curPage="curPage"
                :config="tableConfig"
                :dataset="tableData"
                :total="standTotal"
                @columnClick="tableColumnClick"
                @bottomBtnClick="bottomBtnClick"
                @pageChange="pageChange"
            />
        </div>
    </div>
</template>

<script>
import Table from "@/views/zhiji/bComponents/table/Table";
import QuestionTrees from "./components/QuestionTrees";
import OperationBar from "./components/OperationBar";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";

import { recursionTrans, recursionFind } from "@/views/zhiji/js/common/util.js";
import { quesListTable } from "./pageConfig.js";
import i18n from "@/i18n";

export default {
    name: "QuestionDetail",
    components: {
        Table,
        OperationBar,
        QuestionTrees
    },
    data() {
        return {
            curPage: 1,
            curPageLen: quesListTable().pageLength,
            selectedQuestion: [],
            selectedQs: '',
            initQuestionId: "", // 初始问题ID
        };
    },
    computed: {
        tableData() {
            return this.getStorePorp("tableDatas");
        },
        standTotal() {
            return this.getStorePorp("standTotal");
        },
        extandTotal() {
            return this.getStorePorp("extandTotal");
        },
        answerTotal() {
            return this.getStorePorp("answerTotal");
        },
        classMenu() {
            let treeData = this.getStorePorp("treeData").children || [];
            return recursionTrans(
                treeData,
                function(treesData) {
                    return {
                        value: treesData.id,
                        label: treesData.label
                    };
                },
                "children"
            );
        },
        currentScene() {
            let selectedSceneId = this.getStorePorp("querySetting").classId;

            return selectedSceneId ? this.getSceneNameById(selectedSceneId) : i18n.t("zhiji.common.allClassify");
        },
        tableConfig() {
            return this.getTableConfig();
        },
        hasQuestionId() {
            if (this.$route.query.questionId) {
                return this.$route.query.questionId;
            }
            return false;
        }
    },
    mounted() {
        this.$store.commit("zhiji/initQuerySetting");
        let reqParam = {
            page: this.curPage,
            size: this.curPageLen,
            classId: ""
        };
        this.getQuestionList(reqParam);
        // 路由携带了questionId 则跳转到该questionId的问题编辑页
        if (this.hasQuestionId) {
            this.initQuestionId = this.hasQuestionId;
            setTimeout(() => {
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: this.hasQuestionId,
                        curPanel: "AnswerPanel",
                        hasRecommendSimilar: false
                    },
                });
                this.$router.push({ query: {} });
            }, 1000);
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        getQuestionList(reqParam) {
            this.$store.dispatch("zhiji/queryQuestionList", reqParam);
            this.$store.dispatch("zhiji/queryExtQuestionTotal", reqParam);
            this.$store.dispatch("zhiji/queryAnswersTotal", reqParam);
        },
        initCurrPage() {
            this.curPage = 1;
        },
        getTableConfig() {
            let newTableData = quesListTable();
            newTableData.bottomButtons.some(button => {
                if (button.id === "transfer") {
                    button.getOptions = () => this.classMenu;
                    return true;
                }
            });
            return newTableData;
        },
        tableColumnClick(data) {
            // 标准问题点击
            if (data.colId === "standQuestion") {
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.rowId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "AnswerPanel",
                        hasRecommendSimilar: data.rowData.addData.recommendSimilar,
                        closeHandler: () => {
                            this.getQuestionList({
                                page: this.curPage
                            });
                        }
                    }
                });
            } else if (data.colId === "similarQuestion") {
                // 相似问题点击
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.rowId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "SimilarPanel",
                        currentTab: "ExistingSimilars",
                        hasRecommendSimilar: data.rowData.addData.recommendSimilar,
                        closeHandler: () => {
                            this.getQuestionList({
                                page: this.curPage
                            });
                        }
                    }
                });
            }
        },
        bottomBtnClick(buttonId, selectedRowIds, option) {
            this.bottomClickAction(selectedRowIds, buttonId, option);
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getQuestionList({
                page: data.curPage,
                size: data.pageLength
            });
        },
        collectCheckedQues (editData) {
            editData.forEach((item) => {
                const isExitIndex = this.selectedQuestion.indexOf(item);
                this.tableData.forEach(({ question, rowId }) => {
                    if (item === rowId && isExitIndex === -1) {
                        this.selectedQuestion.push(question);
                   }
                });
            });
            this.selectedQs = this.selectedQuestion.join(',')
        },
        // table底部按钮操作总入口
        bottomClickAction(editData, data, option) {
            this.selectedQuestion.length = 0;
            this.collectCheckedQues(editData);
            const handlers = {
                delete: this.deleteAction,
                online: this.onlineAction,
                offline: this.offlineAction,
                transfer: this.transferAction,
                export: this.exportAction
            };

            handlers[data].call(null, editData, option);
        },
        onlineAction(selectedRowIds) {
            if (!selectedRowIds.length) {
                this.messageTip(i18n.t("zhiji.knowlege.selectQuesLabel"));
                return;
            }
            const questionId = this.getQuestionId(selectedRowIds);
            if (questionId.length > 0) {
                let tipStr = i18n.t("zhiji.knowlege.onlineRelatedTip");
                questionId.map(item => {
                    tipStr += `\n ${this.getQuestion(item)}(${i18n.t("zhiji.knowlege.questionName")})， question_id=${item}`;
                });
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: tipStr,
                        cancel: () => {},
                        confirm: () => {
                            this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                                status: "online",
                                questionId: [...questionId],
                                question: this.selectedQs
                            });
                        }
                    }
                });
            } else {
                this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                    status: "online",
                    questionId: [...selectedRowIds],
                    question: this.selectedQs
                });
            }
        },
        // 通过问题id找到问题标准问语
        getQuestion(questionId) {
            const questionObj = this.tableData.find(item => item.rowId === questionId);
            return questionObj.question;
        },
        // 过滤首问语跟兜底话术
        isSelectedFirstOrReveal(selectedRowIds) {
            const selectedRows = this.tableData.filter(value => selectedRowIds.indexOf(value.rowId) !== -1);
            return selectedRows.some(row => row.state === "first" || row.state === "reveal");
        },
        // 批量操作时去除首问语跟兜底
        excludeFirstAndReveal(state, selectedRowIds, option) {
            const options = {
                delete: {
                    tips: i18n.t("zhiji.knowlege.deleteQuesTip3"),
                    handler: this.deleteAction,
                },
                offline: {
                    tips: i18n.t("zhiji.knowlege.offlineQuesTip3"),
                    handler: this.offlineAction,
                },
                transfer: {
                    tips: i18n.t("zhiji.knowlege.transferQuesTip"),
                    handler: this.transferAction,
                }
            };
            // 剔除首问语、兜底话术的标问
            const selectedRows = this.tableData.filter(value => selectedRowIds.indexOf(value.rowId) !== -1);
            const otherRows = selectedRows.filter(item => item.state !== "first" && item.state !== "reveal");
            // 筛选出剔除首问语、兜底话术的标问id列表
            const otherRowIds = otherRows.map(item => item.rowId);
            const message = options[state].tips;
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message,
                    lineFeed: true,
                    confirm: () => {
                        // 确认后重新执行之前的方法
                        options[state].handler.call(null, otherRowIds, option);
                    }
                }
            });
        },
        offlineAction(selectedRowIds) {
            if (!selectedRowIds.length) {
                this.messageTip(i18n.t("zhiji.knowlege.selectQuesLabel"));
                return;
            }
            if (this.isSelectedFirstOrReveal(selectedRowIds)) {
                this.excludeFirstAndReveal("offline", selectedRowIds);
                return;
            }
            const questionId = this.getQuestionId(selectedRowIds);
            if (questionId.length > 0) {
                this.effectQuestion(questionId.join(","), i18n.t("zhiji.knowlege.offlineRelatedTip"), () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: "offline",
                        questionId: [...selectedRowIds],
                        question: this.selectedQs
                    });
                });
            } else {
                let configText = selectedRowIds.length > 1 ? i18n.t("zhiji.knowlege.offlineQuesTip2") : i18n.t("zhiji.knowlege.offlineQuesTip1");
                this.messageTip(configText, () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: "offline",
                        questionId: [...selectedRowIds],
                        question: this.selectedQs
                    });
                });
            }
        },
        addTransferJudge(questionIds,option){
            this.zhiji
                .requestByServiceName("judgeExistAloneNonDefault",{ questionIds })
                .then(res => {
                    if (res.exist) {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "tip",
                                message: i18n.t("zhiji.knowlege.addTransferCurtailment"),
                                lineFeed: true,
                                confirm: () => {
                                    this.$store.dispatch("zhiji/transferQuestions", {
                                        classId: option.value,
                                        questionIds
                                    });
                                }
                            }
                        });
                    }else {
                        this.$store.dispatch("zhiji/transferQuestions", {
                            classId: option.value,
                            questionIds
                        });
                    }
                })
        },
        transferAction(selectedRowIds, option) {
            if (selectedRowIds.length > 0) {
                if (this.isSelectedFirstOrReveal(selectedRowIds)) {
                    this.excludeFirstAndReveal("transfer", selectedRowIds, option);
                    return;
                }
                this.$store.dispatch("zhiji/transferQuestions", {
                    classId: option.value,
                    questionIds: [...selectedRowIds],
                    question: this.selectedQs
                });
                this.showSuccessTip(this.$t("zhiji.knowlege.transferSuc"));
                const questionIds = selectedRowIds.join();
                this.addTransferJudge(questionIds, option);
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("zhiji.knowlege.selectQuesLabel")
                    }
                });
            }
        },
        deleteAction(selectedRowIds) {
            if (!selectedRowIds.length) {
                this.messageTip(i18n.t("zhiji.knowlege.selectQuesLabel"));
                return;
            }
            if (this.isSelectedFirstOrReveal(selectedRowIds)) {
                this.excludeFirstAndReveal("delete", selectedRowIds);
                return;
            }
            const questionId = this.getQuestionId(selectedRowIds);
            if (questionId.length > 0) {
                this.effectQuestion(questionId.join(","), i18n.t("zhiji.knowlege.deleteRelatedTip"), () => {
                    this.$store.dispatch("zhiji/deleteQuestions", {
                        questionId: [...selectedRowIds],
                        question: this.selectedQs
                    });
                });
            } else {
                let configText = selectedRowIds.length > 1 ? i18n.t("zhiji.knowlege.deleteQuesTip2") : i18n.t("zhiji.knowlege.deleteQuesTip1");
                this.messageTip(configText, () => {
                    this.$store.dispatch("zhiji/deleteQuestions", {
                        questionId: [...selectedRowIds],
                        question: this.selectedQs
                    });
                });
            }
        },
        exportAction(selectedRowIds) {
            if (selectedRowIds.length > 0) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "ExportFaqModal",
                    data: {
                        type: "question_ids",
                        rowIds: selectedRowIds
                    }
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("zhiji.knowlege.exportModal.notSelected")
                    }
                });
            }
        },
        getSceneNameById(sceneId) {
            const treeData = this.getStorePorp("treeData").children || [];

            let scene = recursionFind(
                treeData,
                nodeData => {
                    return nodeData.id == sceneId;
                },
                "children"
            );

            return scene ? scene.label : "";
        },
        selectHandle() {
            this.initCurrPage();
        },
        messageTip(tipTxt, callBack = () => {}) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipTxt,
                    cancel: () => {},
                    confirm: () => {
                        callBack();
                    }
                }
            });
        },
        // 获取为默认语种的标问id
        getQuestionId(selectedRowIds) {
            const treeData = this.getStorePorp("tableDatas") || [];
            // 获取当前的默认语种
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang || "en";
            return selectedRowIds.filter(item => {
                return treeData.some(child => item === child.rowId && child.addData.langType === defaultLang);
            });
        },
        // 提示被影响的相关标问
        effectQuestion(questionId, tipTxt, callBack) {
            this.zhiji
                .requestByServiceName("getRelatedQuestion", {
                    questionId
                })
                .then(resp => {
                    let tipStr = tipTxt;
                    resp.map(item => {
                        tipStr += `\n ${item.question}(${i18n.t("zhiji.knowlege.questionName")})， question_id=${item.questionId}`;
                    });
                    resp.length &&
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "tip",
                                message: tipStr,
                                cancel: () => {},
                                confirm: () => {
                                    callBack();
                                }
                            }
                        });
                });
        },
        showSuccessTip(message) {
            this.$message({
                message: message,
                center: true,
                duration: 2000,
                type: "success"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.question-list-page {
    height: 100%;
    display: flex;
    box-sizing: border-box;

    .question-table {
        display: flex;
        flex: 1;
        flex-direction: column;
        overflow: auto;

        .content-top {
            position: relative;
            padding: 15px 16px 0 24px;
            box-sizing: border-box;
            > p {
                margin-top: 10px;
            }
            em {
                color: #00c972;
            }
            .tit {
                font-size: 14px;
            }
            /deep/ .content-opeat {
                margin-top: 20px;
                .opeat-l {
                    margin-right: 45px;
                }
            }
        }
    }
}
</style>
